import { lazy } from "react";
import PageviewIcon from "@mui/icons-material/Pageview";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { Navigate } from "react-router-dom";

const TripSearchList = lazy(() => import("../components/tripList"));
const EmployeeRouteMap = lazy(() => import("../../trip-management/trip-billing/components/tripList/components/employee-route-map"));

const tripSearchRoute = {
  icon: DirectionsCarIcon,
  name: "Trip Management",
  link: "/trip-management",
  path: "trip-management",
  index: 8,
  element: "",
  superAdminView: false,
  children: [
    {
      path: "trips-search",
      element: <TripSearchList />,
      permission: "Trip-Read",
      name: "Trips Search",
      index: 9,
      link: "trip-management/trips-search",
      icon: PageviewIcon,
    },
    // {
    //   path: "trips-search/view/:type/:id",
    //   element: <TripDetailPage />,
    // },
    {
      path: "trips-search/:id",
      element: <EmployeeRouteMap />
    },
    {
      path: "trips-search/view",
      element: <Navigate to="/trip-management/trips-search" replace />,
    },
    {
      path: "trips-search/view/:type",
      element: <Navigate to="/trip-management/trips-search" replace />,
    },
    {
      path: "",
      element: <Navigate to="/trip-management/trips-search" replace />,
    },
  ],
};
export default tripSearchRoute;
